function initials(name = "") {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() || "")
    .join("");
}

export default function Testimonials({ section, items = [] }) {
  if (!section || section.is_enabled === 0) return null;

  return (
    <section className="testimonials section section--alt" aria-label="Student testimonials">
      <div className="section__inner">
        <div className="section__header">
          {section.badge && <span className="section__tag">{section.badge}</span>}
          <h2 className="section__title">{section.title}</h2>
          {section.subtitle && <p className="section__subtitle">{section.subtitle}</p>}
        </div>

        <div className="testimonials__grid">
          {items.map((item) => (
            <div key={item.id} className="testimonial-card">
              <div className="testimonial-card__quote-mark" aria-hidden="true">"</div>
              <p className="testimonial-card__text">{item.body}</p>
              <div className="testimonial-card__author">
                {item.image_url ? (
                  <img src={item.image_url} alt={item.title} className="testimonial-card__avatar testimonial-card__avatar--image" loading="lazy" />
                ) : (
                  <div className="testimonial-card__avatar" aria-hidden="true">{initials(item.title)}</div>
                )}
                <div>
                  <p className="testimonial-card__name">{item.title}</p>
                  <p className="testimonial-card__program">{item.subtitle}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
